// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__350hg","header":"Messages_header__4W65w"};